<template>
  <transition name="right-slide" appear>
    <div class="right-slide-modal" v-if="isOpen">
      <div class="right-slide-modal__overlay"></div>
      <div
        class="right-slide-modal__panel"
        role="dialog"
        aria-modal="true"
      >
        <button class="right-slide-modal__close" type="button" @click="$emit('close')">
          &times;
        </button>
        <div v-if="$slots.header" class="right-slide-modal__header">
          <slot name="header" />
        </div>
        <div
          class="right-slide-modal__body"
          :class="{ 'right-slide-modal__body--scroll': scroll }"
        >
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'RightSlideModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: false
    },
    scroll: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  watch: {
    open () {
      this.isOpen = this.open
    }
  },
  mounted () {
    this.isOpen = this.open
    document.addEventListener('keydown', this.closeOnEscapeKey)
    if (this.closeOnOutsideClick) {
      document.addEventListener('click', this.handleOutsideClick)
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.closeOnEscapeKey)
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    handleOutsideClick (e) {
      if (this.closeOnOutsideClick && e.target.classList.contains('right-slide-modal__overlay')) {
        this.$emit('close')
      }
    },
    closeOnEscapeKey (event) {
      if (event.key === 'Escape' && !this.isOpen) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.right-slide-modal {
  position: fixed;
  inset: 0;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  pointer-events: auto;

  &__overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
  }

  &__panel {
    position: relative;
    width: 720px;
    height: 100%;
    max-height: 97vh;
    border-radius: 15px;
    max-width: 92vw;
    background: #ffffff;
    box-shadow: -12px 0 32px rgba(15, 23, 42, 0.15);
    display: flex;
    flex-direction: column;
    margin-right: 15px;
  }

  &__close {
    position: absolute;
    top: 18px;
    right: 18px;
    border: none;
    background: transparent;
    font-size: 22px;
    color: #2f2f2f;
    cursor: pointer;
    z-index: 2;
  }

  &__header {
    padding: 24px 32px 16px 32px;
    border-bottom: 1px solid #e5e7eb;
  }

  &__body {
    flex: 1;
    padding: 0 0 24px 0;
    overflow: hidden;
  }

  &__body--scroll {
    border-radius: 14px;
    overflow-y: auto;
  }

}

@media (max-width: 640px) {
  .right-slide-modal {
    &__panel {
      width: 100vw;
    }
    &__header {
      padding: 20px;
    }
  }
}

.right-slide-enter-active,
.right-slide-leave-active {
  transition: opacity 0.25s ease;
}

.right-slide-enter-active .right-slide-modal__panel,
.right-slide-leave-active .right-slide-modal__panel {
  transition: transform 0.3s ease;
}

.right-slide-enter-active .right-slide-modal__overlay,
.right-slide-leave-active .right-slide-modal__overlay {
  transition: opacity 0.25s ease;
}

.right-slide-enter,
.right-slide-leave-to {
  opacity: 0;
}

.right-slide-enter .right-slide-modal__panel,
.right-slide-leave-to .right-slide-modal__panel {
  transform: translateX(100%);
}

.right-slide-enter .right-slide-modal__overlay,
.right-slide-leave-to .right-slide-modal__overlay {
  opacity: 0;
}
</style>
